import React from 'react';
import { brandWordmark, foxAppIcon } from '../lib/brandAssets';
interface WordmarkProps {
  /**
   * Sizing only. Pass explicit width AND height classes (e.g. "h-[64px] w-[96px]"),
   * or a width class plus "h-auto". The component sets no default size, so the
   * caller's classes are never fighting a built-in one.
   */
  className?: string;
  /** Pass false when the wordmark sits inside a link that already names it. */
  decorative?: boolean;
  eager?: boolean;
}

/** The approved wordmark artwork, feathered only at its empty outer edges. */
export function Wordmark({
  className = '',
  decorative = false,
  eager = false
}: WordmarkProps) {
  return <img src={brandWordmark.src} alt={decorative ? '' : brandWordmark.alt} width={brandWordmark.width} height={brandWordmark.height} loading={eager ? 'eager' : 'lazy'} decoding={eager ? undefined : 'async'} className={`feather-edges block max-w-full shrink-0 select-none object-contain ${className}`} style={{
    aspectRatio: `${brandWordmark.width} / ${brandWordmark.height}`
  }} draggable={false} data-id="element-87" data-mp="rle466wjoito" />;
}
interface FoxIconProps {
  className?: string;
  decorative?: boolean;
}

/** The lavender fox app icon with a subtle 1px ink outline. */
export function FoxIcon({
  className = 'h-10 w-10',
  decorative = true
}: FoxIconProps) {
  return <img src={foxAppIcon.src} alt={decorative ? '' : foxAppIcon.alt} width={foxAppIcon.width} height={foxAppIcon.height} loading="lazy" decoding="async" className={`rounded-[24%] border border-ink object-contain ${className}`} data-id="element-88" data-mp="3h303v4mjeihk" />;
}